import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import { IInfoCenterState } from "./types";
import { IIDAStore } from "../types";
import { institutionService } from "../../services/institution.service";
import { InfoCenterItem } from "../../components/IstInfoCenterItem";
import { LogonMessage } from "../../models/loginMessages-model";
import { INewstype } from "../../components/IstInfoCenter";
import IstInfoCenterItem from "../../components/IstInfoCenterItem.vue";
import { Dialog } from "quasar";
import i18n from "../../i18n";
import filters from "@/components/filters/Filters";

export const getInitialState = (): IInfoCenterState => {
  return {
    infoCenterItems: []
  };
};

const namespaced = true;

export const getters: GetterTree<IInfoCenterState, IIDAStore> = {
  getInfoCenterItems: (state) => () => {
    return state.infoCenterItems;
  }
};

export const actions: ActionTree<IInfoCenterState, IIDAStore> = {
  reset({ commit }) {
    commit("reset");
  },
  fetchInfoCenter({ commit, state }): Promise<INewstype[]> {
    return new Promise((resolve, reject) => {
      try {
        const logonMessageIdsRead = localStorage.getItem("logonMessageIdsRead")?.split(",");
        let messageStyle = "width: 50%; max-width: 50%;overflow-wrap: break-word;";
        if (window.innerWidth < 600) {
          messageStyle = "width: 100%; max-width: 100%;overflow-wrap: break-word;";
        }
        institutionService.fetchLoginMessages().then((logonMessages: LogonMessage[]) => {
          const orderedLogonMessages = logonMessages.sort((a, b) => {
            return b.show_from.getTime() - a.show_from.getTime();
          });
          let displayMessage = "";
          const infoCenterItems: INewstype[] = state.infoCenterItems.map((a) => a);
          for (let index = 0; index < orderedLogonMessages.length; index++) {
            const logonMessage = orderedLogonMessages[index];
            const news: INewstype = {} as INewstype;
            news.id = logonMessage.id.toString();
            news.category = "IST";
            news.component = IstInfoCenterItem;
            news.unread = logonMessageIdsRead ? !logonMessageIdsRead.includes(news.id) : true;
            news.categoryIcon = "mdi-message-text-clock-outline";
            news.payload = new InfoCenterItem();
            news.payload.category = news.category;
            news.payload.categoryIcon = news.categoryIcon;
            news.payload.time = logonMessage.created_at;
            news.payload.title = logonMessage.info;

            news.payload.onClick = () => {
              Dialog.create({
                title: i18n.global.t("infocenter.message").toString(),
                message: news.payload.title,
                color: "primary",
                html: true,
                style: "width: 50%; max-width: 50%;overflow-wrap: break-word;",
                ok: {
                  label: news.unread
                    ? i18n.global.t("infocenter.markasread").toString()
                    : i18n.global.t("infocenter.markasunread").toString()
                },
                cancel: {
                  label: i18n.global.t("infocenter.close").toString()
                }
              }).onOk(async () => {
                commit("markInfoCenterToggle", news);
              });
            };
            if (news.unread) {
              displayMessage +=
                "<div class='multiple_messages'>" +
                filters.dateTime(news.payload.time) +
                "<br />" +
                news.payload.title +
                "<br/>&nbsp;</div><br/>";
            }
            infoCenterItems.push(news);
          }
          commit("replaceInfoCenter", infoCenterItems);
          if (displayMessage !== "") {
            Dialog.create({
              title: i18n.global.t("infocenter.message").toString(),
              message: displayMessage,
              color: "primary",
              html: true,
              persistent: true,
              ok: {
                label: i18n.global.t("infocenter.markasread").toString()
              },
              style: messageStyle,
              cancel: {
                label: i18n.global.t("infocenter.close").toString()
              }
            }).onOk(async () => {
              infoCenterItems.forEach((e) => {
                commit("markInfoCenterRead", e);
              });
            });
          }

          return resolve(infoCenterItems);
        });
      } catch (error) {
        return reject(error);
      }
    });
  },
  addInfoCenter({ commit, state }, newNewstype: INewstype): Promise<INewstype[]> {
    return new Promise((resolve, reject) => {
      try {
        const infoCenterItems: INewstype[] = state.infoCenterItems.map((a) => a);
        infoCenterItems.push(newNewstype);
        commit("replaceInfoCenter", infoCenterItems);
        return resolve(infoCenterItems);
      } catch (error) {
        return reject(error);
      }
    });
  }
};

export const mutations: MutationTree<IInfoCenterState> = {
  reset(state: IInfoCenterState) {
    Object.assign(state, getInitialState());
  },
  replaceInfoCenter(state: IInfoCenterState, infoCenterItem: INewstype[]) {
    state.infoCenterItems = infoCenterItem;
  },
  markInfoCenterRead(state: IInfoCenterState, infoCenterItem: INewstype) {
    const item = state.infoCenterItems.find((i) => i.id === infoCenterItem.id);
    WriteMessageIdsRead(item, true);
  },
  markInfoCenterToggle(state: IInfoCenterState, infoCenterItem: INewstype) {
    const item = state.infoCenterItems.find((i) => i.id === infoCenterItem.id);
    WriteMessageIdsRead(item, item ? item.unread : false);
  }
};

export const infoCenterStoreModule: Module<IInfoCenterState, IIDAStore> = {
  namespaced: namespaced,
  state: getInitialState(),
  getters: getters,
  actions: actions,
  mutations: mutations
};

function WriteMessageIdsRead(item: INewstype | undefined, markAsRead: boolean) {
  if (item) {
    item.unread = !markAsRead;
    let logonMessageIdsRead = localStorage.getItem("logonMessageIdsRead")?.split(",");
    logonMessageIdsRead = logonMessageIdsRead ? logonMessageIdsRead : [];
    if (item.id) {
      if (markAsRead) {
        logonMessageIdsRead.push(item.id?.toString());
      } else {
        logonMessageIdsRead = logonMessageIdsRead.filter((a) => a !== item.id);
      }
    }
    localStorage.setItem(
      "logonMessageIdsRead",
      logonMessageIdsRead.filter((item, i, ar) => ar.indexOf(item) === i).join()
    );
  }
}
